
import { useContext } from 'react';
import { CMSContext } from '../contexts/CMSContext';
import useLog from './useLog';


const CMS_URL = process.env.REACT_APP_API_HOST; 
const FUNCTION_KEY = process.env.REACT_APP_FUNCTION_KEY;


export default function useCMS() {
    const {LogInfo, LogError, LogVerbose} = useLog();
    const {
        setBuildingIds,
        setBuildings, 
        setDevices,
        setGateDevices,
        setToken
      } = useContext(CMSContext);

    const GetTokenForUser  = async (userId) => {
        LogInfo('getTokenForUser called with user:  ' +  userId);

       try {
          const api = 'api/GetTokenForUser ';
          const response = await fetch(`${CMS_URL}${api}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-functions-key': FUNCTION_KEY
            },
            body: JSON.stringify({ username: userId,
                                    deviceType: "guard",
                                    skipDevices: false
             })
          });
          
          const data = await response.json();
          LogVerbose('GetTokenForUser, setting buildingIds: ' +  data.buildingIdList);
          setBuildingIds(data.buildingIdList);
          setDevices(data.devices ? data.devices[0] : []);
          setGateDevices(data.gateDevices);
          setToken(data.token);
          LogInfo('GetTokenForUser - Token received for user ' +  data.token);
          return data.token;//function must return the token for the token refresher to work
        } catch (error) {
          LogError('Failed to get token:', error);
          
          return null;
        }
      };

  
  const FetchBuildingData = async (buildingIds, userId) => {
    try {
      LogInfo('useCMS: FetchBuildingData for user ' +  userId);
      //request building data for each building id in parallel
      const promises = buildingIds.map(id =>
        fetch(`${CMS_URL}api/GetBuildingConfiguration`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-functions-key': FUNCTION_KEY,
            'cms-device-id': userId
          },
          body: JSON.stringify({ buildingid: id })
        }).then(res => res.json())
      );
      const buildingsData = await Promise.all(promises); //wait for all promises to resolve
      setBuildings(buildingsData.map(building => building[0])); // Flatten in case of nested arrays
    } catch (error) {
      LogError('Failed to fetch building data:', error);
    }
  };

      return {
        GetTokenForUser,FetchBuildingData
      };

    
}

